/**
 * The desktop app's copies of generated files (owner, 2026-10-22: every file Gyro creates is saved in
 * Documents\Gyro\<chat name> as soon as it appears; desktopAutoSave.tsx), as the components under a chat see them: the
 * Export outputs (DocumentOutputs), a code block's Markdown download (ChatMarkdown) and the line under a file list
 * (GeneratedFiles). Null on every other host (the web panel, the Office pane), where nothing changes. Kept to a type and a
 * context so the web entry, which renders ChatMarkdown and GeneratedFiles too, carries none of the desktop code.
 */
import { createContext } from 'react';
export const AutoSaveContext = createContext(null);
//# sourceMappingURL=autoSaveContext.js.map